:host {
  display: block;
  max-width: 100%;
  --apex-yaxis-label-color: var(--chart-300-icon-buttons);
  --apex-xaxis-label-color: var(--chart-300-icon-buttons);
}

:host([theme='dark']) {
  .tooltip {
    color: var(--white-layout-303-level-2-elevation);
    background-color: var(--body-text-arrows-400);
  }
  .apexcharts-datalabels-group {
    text {
      fill: var(--main-titles-inputs-600) !important;
    }
  }
  .apexcharts-legend-series {
    .chart-legend {
      .chart-legend-text,
      .chart-legend-value {
        color: var(--white-layout-300-primary);
      }
    }
  }
}

.apexcharts-title-text {
  fill: var(--main-titles-inputs-600);
}

:host([type='area']),
:host([type='line']),
:host([type='bar']),
:host([type='radar']){
  .apexcharts{
    &-yaxis {
      text {
        font-size: var(--body-size-small);
        fill: var(--main-titles-inputs-600);
      }
    }
    &-xaxis {
      text {
        font-size: var(--body-size);
        fill: var(--main-titles-inputs-600);
      }
    }
  }
  //this line is for emptyMessage text
  foreignObject + .apexcharts-text {
    font-size: var(--body-size-large);
    fill: var(--main-titles-inputs-600) !important;
  }
}

.apexcharts-legend-text {
  font-size: var(--body-size-large) !important;
  color: var(--main-titles-inputs-600) !important;
  * {
    font-family: var(--font-family-secondary-mono);
    font-size: var(--body-size);
    padding-left: var(--spacer);
  }
}

.apexcharts-grid-borders line,
.apexcharts-xaxis-tick {
  stroke: var(--chart-101-pressed-dividers);
}


:host([type='donut']) {
  .apexcharts-graphical {
    .apexcharts-pie {
      transform: translate(-130px, 8px);
    }
  }

  .apexcharts-datalabels-group {
    .apexcharts-datalabel {
      &-label {
        font-size: var(--donut-datalabel-label);
        fill: var(--main-titles-inputs-600) !important;
      }
      &-value {
        font-size: var(--donut-datalabel-value);
        fill: var(--main-titles-inputs-600) !important;
      }
    }
  }

  .apexcharts-legend {
    transform: translate(-100px, 55px);
    max-width: 250px;
  }

  .apexcharts-legend-text {
    b {
      padding-left: var(--spacer);
    }
  }

  .apexcharts-legend-series {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .apexcharts-legend-text {
    flex: 1 1 0;
    width: 100%;
  }

  .apexcharts-legend-text *,
  .apexcharts-legend-marker * {
    pointer-events: all;
    cursor: default;
  }

  .chart-legend {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: calc(var(--spacer) * 4);
    min-width: 0;

    .chart-legend-value,
    gz-text {
      cursor: text;
      user-select: text;
    }

    .chart-legend-value {
      font-weight: bold;
      font-family: var(--font-family-secondary-mono);
    }

    gz-text {
      display: inline;
    }
  }

  .apexcharts-pie-series {
    .apexcharts-pie-area {
      stroke: var(--white-layout-302-level-1-elevation);
    }
  }
}

:host([type='donut'][state='is-empty']) {
  .apexcharts-legend {
    transform: translate(-250px, 60px);
  }
}

.chart-container {
  width: var(--container-custom-width, 100%);
  height: var(--container-custom-height, 100%);
}

.apexcharts-xaxistooltip,
.apexcharts-yaxistooltip {
  background: var(--white-layout-303-level-2-elevation);
  border-color: var(--chart-101-pressed-dividers) !important;

  &-text {
    color: var(--main-titles-inputs-600);
  }
}

.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: var(--white-layout-303-level-2-elevation) !important;
}

.apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: var(--chart-101-pressed-dividers) !important;
}

.apexcharts-yaxis,
.apexcharts-xaxis {
  .apexcharts-text tspan {
    fill: var(--main-titles-inputs-600);
  }
}

.apexcharts-tooltip {
  left: var(--tooltip-left-position) !important;
  transition: none;
  box-shadow: none;
  border: 1px solid var(--chart-101-pressed-dividers) !important;
  background: var(--white-layout-303-level-2-elevation) !important;

  &.apexcharts-active {
    transition: none;
  }

  .tooltip {
    background-color: var(--white-layout-303-level-2-elevation);
    color: var(--main-titles-inputs-600);
    padding: calc(3 * var(--spacer));
    font-size: var(--body-size);
    white-space: normal;
    display: flex;
    align-items: center;
    max-width: var(--tooltip-width);
    min-width: var(--tooltip-min-width);

    &--bullet {
      width: 10px;
      height: 10px;
      display: inline-block;
      margin-right: var(--spacer);
    }

    &--value {
      font-weight: bold;
      margin-left: calc(var(--spacer) - 5px);
    }
  }
}

.apexcharts-legend-text {
  cursor: var(--apex-legend-cursor, auto);

  &:hover {
    color: var(--apex-legend-text-color, var(--main-titles-inputs-600)) !important;
    opacity: var(--apex-legend-hover-opacity, 1) !important;
  }
}

.apexcharts-yaxis-label tspan {
  fill: var(--apex-yaxis-label-color) !important;
  font-family: var(--font-family-secondary-mono);
}

.apexcharts-xaxis-label tspan {
  fill: var(--apex-xaxis-label-color) !important;
}

.apexcharts-text,
.apexcharts-legend-text {
  font-family: var(--font-family-secondary), serif !important;
}
